import Actions from '../action'

const initialState = {
    isLoading: false,
    orders: {},
    error: false
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_CUSTOMER_ORDERS: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GET_CUSTOMER_ORDERS_SUCCESS: {
            let { data } = action.orders
            return {
                ...state,
                isLoading: false,
                orders: data && data.customer,
                error: false
            };
        }
        case Actions.GET_CUSTOMER_ORDERS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        default:
            return state;
    }

};